import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import * as uiActions from '~actions/ui-actions';

import * as identityProviderAPI from '~api/identity-providers';

import ActionButton from '~components/general/action-button';
import IString from '~components/general/i-string';
import { IdentityProvider } from '~components/identity-providers/identity-provider-prop-types';

import { translate } from '~i18n/localize';

import * as formatter from '~util/formatter';

export default function IdentityProviderDetailsMetadata({ identityProvider, onUpdate }) {
  const dispatch = useDispatch();
  const [ editMetadata, setEditMetadata ] = useState(false);
  const [ metadata, setMetadata ] = useState(identityProvider?.metadata);

  const handleFileChange = (e) => {
    if (e.target.files) {

      // Read in a XML file, parse it, make the XML pretty, and then set it as metadata
      const reader = new FileReader();
      reader.onload = () => {
        const xmlContent = formatter.formatXml(reader.result);
        setMetadata(xmlContent);
        setEditMetadata(true);
      };
      reader.readAsText(e.target.files[0]);
    }
  };

  const handleCancel = () => {
    setEditMetadata(false);
    setMetadata(identityProvider.metadata);
  };

  const handleSaveMetadata = async () => {
    setEditMetadata(false);
    const formattedMetadata = formatter.formatXml(metadata);
    setMetadata(formattedMetadata);

    if (identityProvider.metadata !== formattedMetadata) {
      try {
        const updatedIdentityProvider = await identityProviderAPI.updateIdentityProvider(
          identityProvider.id,
          { metadata: formattedMetadata }
        );
        onUpdate(updatedIdentityProvider);
      } catch (error) {
        dispatch(uiActions.setErrorMessage(error));
      }
    }
  };

  return <>
    <div className="sectionTitle flex">
      <IString stringKey="identityProvider.details.sectionTitles.metadata" />
      <div className="actionBar inline showTitles">
        {editMetadata && (
          <>
            <ActionButton className="back" title={translate('general.cancel')} onClick={handleCancel} />
            <ActionButton className="checked" title={translate('general.save')} onClick={handleSaveMetadata} />
          </>
        )}
        {!editMetadata && (
          <>
            <ActionButton className="edit" title={translate('general.edit')} onClick={() => setEditMetadata(true)} />
            <input type="file" id="metadataUpload" style={{ display: 'none' }} accept="application/xml" onChange={handleFileChange} />
            <ActionButton className="share" title={translate('general.upload')} onClick={() => document.getElementById('metadataUpload').click()} />
          </>
        )}
      </div>
    </div>
    <div className="section">
      { editMetadata
        ? (
          <div className="flex">
            <textarea
              className="full"
              value={metadata}
              onChange={e => setMetadata(e.target.value)}
              style={{ height: '400px' }}
            />
          </div>
        ) : <pre style={{ height: '400px' }}>{metadata}</pre>
      }
    </div>
  </>;
}

IdentityProviderDetailsMetadata.propTypes = {
  identityProvider: IdentityProvider.isRequired,
  onUpdate: PropTypes.func.isRequired
};
